import React from 'react';
import './VillasLandingPage.scss';
import grill2 from '../Assets/grill2.jpg';
// import lights from '../Assets/dritat.jpg';
// import k from '../Assets/k.jpg';
import pool1 from '../Assets/pool1.jpg';
import pool2 from '../Assets/pool2.jpg';
import collage from '../Assets/collage.jpg';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const VillasLandingPage = () => {
  const { t } = useTranslation();

  // Function to handle scrolling to the top
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="villas-landing-page">
      <div className="facilities-section">
        <h2>{t('villasLandingPage.exploreOurVillas')}</h2>
        <ul className="facilities-list">
          <h2>{t('villasLandingPage.rooms')}</h2>
          <h2 className="active">{t('villasLandingPage.grillArea')}</h2>
          <h2>{t('villasLandingPage.balconyTerrace')}</h2>
          <h2>{t('villasLandingPage.kitchen')}</h2>
          <h2>{t('villasLandingPage.swimmingpool')}</h2>
          <Link to="/villas">
            <button className='view-more' onClick={handleScrollToTop}>
              {t('villasLandingPage.exploreMore')}
            </button>
          </Link>
        </ul>
      </div>
      <div className="images-section">
        <img src={grill2} alt="Lounge Area 1" />
        <img src={pool1} alt="Pool" />
        <img src={pool2} alt="Pool" />
      </div>
      <img className='collage' src={collage} alt='Collage-Photo' />
    </div>
  );
};

export default VillasLandingPage;
